import { render, staticRenderFns } from "./export_stu_social_practice.vue?vue&type=template&id=0c17abfe&"
import script from "./export_stu_social_practice.vue?vue&type=script&lang=js&"
export * from "./export_stu_social_practice.vue?vue&type=script&lang=js&"
import style0 from "./export_stu_social_practice.vue?vue&type=style&index=0&id=0c17abfe&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports